import { FormGroupLabel, Spacer, TextField } from '@qbe/ads-core';
import { Controller, FieldValues, UseFormReturn } from 'react-hook-form';
import React, { ComponentProps } from 'react';
import { FormSpacer } from 'components';

type TextFieldProps = ComponentProps<typeof TextField>;

type Props<T extends FieldValues> = {
  form: UseFormReturn<T>;
  slotProps?: {
    titleField?: { title?: string; required?: boolean };
    firstnameField?: { name?: string; label?: string };
    lastnameField?: { name?: string; label?: string };
  };
} & Partial<TextFieldProps>;

export default function FirstnameLastname<T extends FieldValues>({ form, slotProps, ...rest }: Props<T>) {
  const { control } = form;

  const titleProps = {
    title: '',
    required: true,
    ...slotProps?.titleField,
  };

  const firstFieldName = slotProps?.firstnameField?.name || 'firstName';
  const firstFieldLabel = slotProps?.firstnameField?.label || 'First name';

  const firstNameProps = {
    id: firstFieldName,
    label: firstFieldLabel,
    inputProps: {
      maxLength: 50,
      minLength: 1,
      ['data-track']: firstFieldName,
      ['data-track-value']: 'mask',
      ['data-test']: firstFieldName,
    },
  };

  const lastFieldName = slotProps?.lastnameField?.name || 'lastName';
  const lastFieldLabel = slotProps?.lastnameField?.label || 'Last name';

  const lastNameProps = {
    id: lastFieldName,
    label: lastFieldLabel,
    inputProps: {
      maxLength: 50,
      minLength: 1,
      ['data-track']: lastFieldName,
      ['data-track-value']: 'mask',
      ['data-test']: lastFieldName,
    },
  };

  return (
    <>
      <FormGroupLabel {...titleProps} alignCenter />
      <FormSpacer type="input" />
      <Controller
        name={firstFieldName as any}
        control={control}
        render={({ field: { ref, ...field }, fieldState: { error } }) => (
          <TextField {...field} {...rest} {...firstNameProps} error={!!error?.message} helperText={error?.message} />
        )}
      />

      <Spacer size="md" />

      <Controller
        name={lastFieldName as any}
        control={control}
        render={({ field: { ref, ...field }, fieldState: { error } }) => (
          <TextField {...field} {...rest} {...lastNameProps} error={!!error?.message} helperText={error?.message} />
        )}
      />
    </>
  );
}
